import React from 'react';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const Select = ({ heading, value, onChange, options, ariaLabel, required, optional, isInvalid }) => {
  const { t } = useTranslation();

  return (
    <Form.Group className='my-2' controlId={heading}>
      {heading && (
        <Form.Label>
          {t(heading)}
          {required && <span style={{ color: 'red' }}> *</span>}
          {optional && <span className="text-muted ms-1">({t("optional")})</span>}
        </Form.Label>
      )}

      <Form.Control
        as="select"
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        aria-label={ariaLabel}
        required={required}
        isInvalid={isInvalid}
        style={{ borderRadius: "30px" }}
      >
        {options?.map((option) => (
          <option key={option.value} value={option.value}>
            {t(option.label)}
          </option>
        ))}
      </Form.Control>

      <Form.Control.Feedback type="invalid">
        {t("This field is required.")}
      </Form.Control.Feedback>
    </Form.Group>
  );
};

export default Select;
